// extracted by mini-css-extract-plugin
module.exports = {"InputBox":"_2MzdJ","searchBtn":"_31ETq","SearchBox":"_3tOtz","SearchBox_active":"_3z5Uw"};